var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 5.25 C 2.585938 5.25 2.25 5.585938 2.25 6 L 2.25 7.035156 L 10.335938 13.671875 C 11.304688 14.46875 12.699219 14.46875 13.667969 13.671875 L 21.75 7.035156 L 21.75 6 C 21.75 5.585938 21.414062 5.25 21 5.25 Z M 2.25 9.945312 L 2.25 18 C 2.25 18.414062 2.585938 18.75 3 18.75 L 21 18.75 C 21.414062 18.75 21.75 18.414062 21.75 18 L 21.75 9.945312 L 15.09375 15.414062 C 13.292969 16.890625 10.703125 16.890625 8.90625 15.414062 Z M 0 6 C 0 4.34375 1.34375 3 3 3 L 21 3 C 22.65625 3 24 4.34375 24 6 L 24 18 C 24 19.65625 22.65625 21 21 21 L 3 21 C 1.34375 21 0 19.65625 0 18 Z M 0 6 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/InviteIcon.e20dea5528e7b0be96e4ef2d798a8ebd.svg";
export { ForwardRef as ReactComponent };